var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.crrReport.reportId)?_c('report-power-bi-container',{attrs:{"workspaceId":_vm.crrReport.workspaceId,"reportId":_vm.crrReport.reportId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }